import { Handle, Position } from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import styles from "./nodes.module.css"

const Default = ({ data, selected, dragging, className }) => {
    return (
        <div className={`${styles.node} ${selected ? styles.selected : ''} ${dragging ? styles.dragging : ''} ${className}`}>
            <Handle type="target" position={Position.Top} />
            <span>{data.label}</span>
            <Handle type="source" position={Position.Bottom} id="a" />
        </div>
    )
}

export default Default